import { wsServices } from '../../../../apis'
import type {
  RttPolicyUpdateLockedSchema,
  RTTPolicyUpdateProgressSchema,
  RTTPolicyUpdateSuccessSchema
} from '../types/RTTPolicySubscription.schema'

type RttPolicyUpdateProgress = {
  type: 'RTT_POLICY_UPDATE_PROGRESS'
  data: RTTPolicyUpdateProgressSchema
}

type RttPolicyUpdateLocked = {
  type: 'RTT_POLICY_UPDATE_LOCKED'
  data: RttPolicyUpdateLockedSchema
}

type RttPolicyUpdateSuccess = {
  type: 'RTT_POLICY_UPDATE_SUCCESS'
  data: RTTPolicyUpdateSuccessSchema
}

const channelName = 'Payroll::RttSubscriptionsUpdateChannel'

export const useRTTPoliciesSubscription = wsServices.core.subscription.create({
  subscribePayload: () => ({
    channel: channelName
  }),
  messages: {
    onNotifyUpdateProgress:
      wsServices.core.subscription.defineMessageHandler<RttPolicyUpdateProgress>(
        {
          type: 'RTT_POLICY_UPDATE_PROGRESS'
        }
      ),
    onNotifyUpdateLocked:
      wsServices.core.subscription.defineMessageHandler<RttPolicyUpdateLocked>({
        type: 'RTT_POLICY_UPDATE_LOCKED'
      }),
    onNotifyUpdateSuccess:
      wsServices.core.subscription.defineMessageHandler<RttPolicyUpdateSuccess>(
        {
          type: 'RTT_POLICY_UPDATE_SUCCESS'
        }
      )
  },
  emit: {
    isLocked: async () => {
      wsServices.core.ws.send({
        data: {
          action: 'is_locked'
        },
        identifier: { channel: channelName }
      })
    }
  }
})
